export const views = {
  researchers: 'researcher',
  organisations: 'organisation',
};

export const deletePermissionsError =
  'You require Admin Access to delete one or more of your selected Lists. Contact the List Owner to update your permissions.';
export const disablePermissionsError =
  'You require Admin Access to pause one or more of your selected Lists. Contact the List Owner to update your permissions.';
export const noPermissions =
  'You do not have permission to perform this action';
